import { getItemToShowFromNodeId } from '../utils/conversationsUtils';

export default function getItemIdsToShowFromNodeIds(nodeIds: string[]): string[] {
    const itemIds = [];
    for (const nodeId of nodeIds) {
        const item = getItemToShowFromNodeId(nodeId);

        // It is possible item is null when it is not in the store or the user
        // is hiding deleted items
        if (item) {
            itemIds.push(item.ItemId.Id);
        }
    }
    return itemIds;
}
